import { css } from '@/styled-system/css';

export const lightboxContent = css({
  bg: 'rgba(42, 42, 51, 0.92)',
});

export const lightboxContainer = css({
  position: 'relative',
  width: '100%',
  height: '100%',
  overflow: 'hidden',
  userSelect: 'none',
});

export const lightboxTrack = css({
  display: 'flex',
  height: '100%',
  overflowX: 'auto',
  scrollSnapType: 'x mandatory',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
});

export const lightboxSlide = css({
  flexShrink: 0,
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  scrollSnapAlign: 'start',
});

export const lightboxImage = css({
  width: '100%',
  height: 'auto',
  pointerEvents: 'none',
  userSelect: 'none',
  md: {
    width: 'auto',
    maxWidth: '95vw',
    maxHeight: '90vh',
    borderRadius: '8px',
  },
});

export const photoCounter = css({
  position: 'absolute',
  bottom: '3x',
  left: '50%',
  transform: 'translateX(-50%)',
  backgroundColor: 'rgba(0, 0, 0, 0.6)',
  color: 'hpxWhite',
  paddingX: '2x',
  paddingY: 'xs',
  borderRadius: '12px',
  fontSize: 'sm',
  fontWeight: '500',
  zIndex: 'zIndexStep',
  md: {
    top: '2x',
    bottom: 'auto',
  },
});

export const arrowButton = css({
  display: 'none',
  md: {
    display: 'flex',
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    border: 'none',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    color: 'hpxBlue600',
    zIndex: 'zIndexStep',
    transitionProperty: 'background-color, transform',
    transitionDuration: '0.2s',
    _hover: {
      backgroundColor: 'rgba(255, 255, 255, 1)',
      transform: 'translateY(-50%) scale(1.05)',
    },
    _disabled: {
      opacity: 0.4,
      cursor: 'default',
      _hover: {
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        transform: 'translateY(-50%)',
      },
    },
    _focusVisible: {
      outlineWidth: '2px',
      outlineStyle: 'solid',
      outlineColor: 'hpxTeal500',
      outlineOffset: '2px',
    },
  },
});

export const arrowButtonPrev = css({
  md: {
    left: '2x',
  },
});

export const arrowButtonNext = css({
  md: {
    right: '2x',
  },
});
